// extracted by mini-css-extract-plugin
export var notificationHost = "_kl-0";